import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalIaNotApprovedRulesPageRoutingModule } from './modal-ia-not-approved-rules-routing.module';

import { ModalIaNotApprovedRulesPage } from './modal-ia-not-approved-rules.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalIaNotApprovedRulesPageRoutingModule
  ],
  declarations: [ModalIaNotApprovedRulesPage]
})
export class ModalIaNotApprovedRulesPageModule {}
